import { useState } from "react";
import { BRAND } from "../constants/brand";
import PageHero from "../components/PageHero";

const NATIONWIDE = [
  "Avalon Health", "Humana", "Medicare", "Multiplan",
  "Railroad Medicare", "Tricare East Region", "Tricare for Life",
  "Tricare Prime", "Tricare West Region", "United Healthcare",
];

const STATE_PLANS = [
  { state: "Alabama", plans: ["BCBS of Alabama", "Blue Advantage of Alabama", "Medicaid of Alabama", "Namci"] },
  { state: "Colorado", plans: ["Medicaid of Colorado"] },
  { state: "Florida", plans: ["Medicaid of Florida"] },
  { state: "Georgia", plans: ["Absolute Total Care", "Ambetter Health Plan of Georgia", "Amerigroup of Georgia", "BCBS of Georgia", "Clover Health Medicare Advantage", "CareSource of Georgia", "Peach State Health Plan", "Medicaid of Georgia", "WellCare of Georgia"] },
  { state: "Illinois", plans: ["Aetna of Illinois", "Medicaid of Illinois", "Medicare of Illinois", "WellCare of Illinois"] },
  { state: "Indiana", plans: ["Absolute Total Care", "Medicare of Indiana", "Medicaid of Indiana"] },
  { state: "Kentucky", plans: ["CareSource of Kentucky", "Medicaid of Kentucky", "Passport of Kentucky", "WellCare of Kentucky"] },
  { state: "Louisiana", plans: ["Aetna of Louisiana", "Healthy Blue of Louisiana", "Medicaid of Louisiana"] },
  { state: "Michigan", plans: ["Medicaid of Michigan"] },
  { state: "Mississippi", plans: ["Medicaid of Mississippi"] },
  { state: "Missouri", plans: ["Medicaid of Missouri"] },
  { state: "New Mexico", plans: ["Medicaid of New Mexico", "Presbyterian of New Mexico"] },
  { state: "North Carolina", plans: ["Medicaid of North Carolina"] },
  { state: "Ohio", plans: ["Medicaid of Ohio", "CareSource of Ohio"] },
  { state: "South Carolina", plans: ["Absolute Total Care", "Medicaid of South Carolina"] },
  { state: "Tennessee", plans: ["Medicaid of Tennessee"] },
  { state: "Texas", plans: ["BCBS of Texas", "Blue Advantage of Texas", "Blue Essentials Network", "Medicaid of Texas"] },
  { state: "West Virginia", plans: ["Medicaid of West Virginia", "CareSource of West Virginia"] },
];

const TABS = ["Insurance Plans", "Provider Coding Guide"];

export default function InsurancePage() {
  const [tab, setTab] = useState(0);

  return (
    <>
      <PageHero eyebrow="PROVIDERS" title="Insurance" highlight="Coverage" subtitle="Labarium accepts a comprehensive range of insurance plans nationwide. View our full network of accepted plans by state." />

      {/* Tab nav */}
      <div style={{ background: BRAND.white, borderBottom: `1px solid ${BRAND.lightGray}`, position: "sticky", top: 72, zIndex: 800 }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 32px", display: "flex" }}>
          {TABS.map((t, i) => (
            <button key={t} onClick={() => setTab(i)} style={{ padding: "18px 28px", background: "none", border: "none", fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: 13, letterSpacing: "0.1em", cursor: "pointer", color: tab === i ? BRAND.navy : BRAND.textMid, borderBottom: tab === i ? `3px solid ${BRAND.navy}` : "3px solid transparent", transition: "all 0.2s" }}>
              {t.toUpperCase()}
            </button>
          ))}
        </div>
      </div>

      <div className="rx-pad" style={{ background: BRAND.offWhite, padding: "64px 32px 80px" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto" }}>

          {tab === 0 && (
            <>
              {/* Nationwide */}
              <div style={{ marginBottom: 48 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
                  <div style={{ width: 4, height: 28, background: BRAND.gold, borderRadius: 2 }} />
                  <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 26, color: BRAND.navy, margin: 0 }}>Nationwide Plans</h2>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))", gap: 12 }}>
                  {NATIONWIDE.map(plan => (
                    <div key={plan} style={{ background: BRAND.white, borderRadius: 10, border: `1px solid ${BRAND.lightGray}`, padding: "14px 18px", display: "flex", alignItems: "center", gap: 10, boxShadow: "0 2px 8px rgba(0,53,122,0.04)" }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: BRAND.gold, flexShrink: 0 }} />
                      <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, fontWeight: 600, color: BRAND.navy }}>{plan}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* By state */}
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
                  <div style={{ width: 4, height: 28, background: BRAND.gold, borderRadius: 2 }} />
                  <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 26, color: BRAND.navy, margin: 0 }}>Plans by State</h2>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 20 }}>
                  {STATE_PLANS.map(({ state, plans }) => (
                    <div key={state} style={{ background: BRAND.white, borderRadius: 14, border: `1px solid ${BRAND.lightGray}`, overflow: "hidden", boxShadow: "0 2px 12px rgba(0,53,122,0.05)" }}>
                      <div style={{ background: BRAND.navy, padding: "14px 20px", position: "relative" }}>
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: BRAND.gold }} />
                        <span style={{ fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: 14, letterSpacing: "0.08em", color: BRAND.white }}>{state}</span>
                      </div>
                      <div style={{ padding: "16px 20px" }}>
                        {plans.map(plan => (
                          <div key={plan} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderBottom: `1px solid ${BRAND.lightGray}` }}>
                            <div style={{ width: 6, height: 6, borderRadius: "50%", background: BRAND.gold, flexShrink: 0 }} />
                            <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: BRAND.textMid }}>{plan}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ marginTop: 48, background: BRAND.navy, borderRadius: 14, padding: "28px 36px", display: "flex", gap: 24, alignItems: "center", flexWrap: "wrap", position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: BRAND.gold }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 11, fontWeight: 700, letterSpacing: "0.2em", color: BRAND.gold, marginBottom: 6 }}>DON'T SEE YOUR PLAN?</div>
                  <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.7)", margin: 0, lineHeight: 1.7 }}>Contact our billing team — we may accept your insurance plan. We accept many additional plans not listed here.</p>
                </div>
                <a href="tel:8777652274" style={{ textDecoration: "none", background: BRAND.gold, color: BRAND.navy, fontFamily: "'Barlow', sans-serif", fontWeight: 700, fontSize: 12, letterSpacing: "0.1em", padding: "13px 24px", borderRadius: 8, flexShrink: 0 }}>CALL (877) 765-2274</a>
              </div>
            </>
          )}

          {tab === 1 && (
            <div style={{ background: BRAND.white, borderRadius: 16, padding: "48px", border: `1px solid ${BRAND.lightGray}`, boxShadow: "0 4px 20px rgba(0,53,122,0.06)" }}>
              <h2 style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 32, color: BRAND.navy, margin: "0 0 20px" }}>Provider Coding Guide</h2>
              <p style={{ fontFamily: "'Barlow', sans-serif", fontSize: 14, color: BRAND.textMid, lineHeight: 1.85, marginBottom: 24 }}>
                Contact our billing department to request our current provider coding guide. We provide comprehensive coding reference materials to all ordering physicians to ensure accurate claim submission and maximum reimbursement.
              </p>
              <div style={{ background: BRAND.offWhite, borderRadius: 12, padding: "24px", border: `1px solid ${BRAND.lightGray}`, marginBottom: 24 }}>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, fontWeight: 700, color: BRAND.navy, marginBottom: 12 }}>CONTACT BILLING</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.16em", color: BRAND.gold, marginBottom: 2 }}>TOLL-FREE</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 15, color: BRAND.navy, fontWeight: 600, marginBottom: 6 }}>(877) 765-2274</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 10, fontWeight: 700, letterSpacing: "0.16em", color: BRAND.gold, marginBottom: 2 }}>DIRECT</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 14, color: BRAND.navy, fontWeight: 600, marginBottom: 6 }}>(850) 460-1484</div>
                <div style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: BRAND.textMid }}>Monday–Friday · 8:00AM–5:30PM</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
